import React from 'react'
import spradlingFormLogo from "./img/spradling-logo.svg";
import { FormattedMessage } from 'react-intl';
import "./styles/StepInfo.scss";
import classNames from 'classnames';
import ChangeLanguage from './components/ChangeLanguage';

const StepInfo = ({ subtitle, additionalInfo, description, localesReducer, changeLanguage }) => {
  const { language = "es" } = localesReducer || {};

  const handlerChangeLanguage = (lang) => {
    changeLanguage(lang);
  }

  return (
    <main 
      title='step-info-header' 
      className="d-flex flex-column flex-lg-row text-center pt-4 position-relative">
      <section className='container order-2'>
        <div className="py-2">
          <img
            src={spradlingFormLogo}
            alt="spradling-logo"
            title="Spradling logo"
          />
        </div>
        <h4 className="step-info__subtitle py-2 pt-lg-2 font-weight-bold m-0">{subtitle}</h4>
        {additionalInfo && <p className="step-info__text text-secondary col-12 px-5 px-lg-0 pb-3 m-0">{additionalInfo}</p>}
        <p className="step-info__text p-0 m-0 text-secondary">
          <FormattedMessage
            id="ProjectStepForm.step0.disclaimer"
            defaultMessage="Ten en cuenta que los campos con (*) son obligatorios."
          />
        </p>
        {description && <p className="step-info__text text-secondary p-0 m-0">{description}</p>}
      </section>
      <section className='step-info__languages d-flex order-1 justify-content-end container'>
        <ChangeLanguage 
          language={language}
          handlerChangeLanguage={handlerChangeLanguage}
        />
      </section>
    </main>
  );
}

export default StepInfo